<script setup>
import { computed } from 'vue'
import ModalBox from './ModalBox.vue'
import ButtonCopyToClipboard from '../Moleculas/ButtonCopyToClipboard.vue'
import FormButton from '@/components/Atoms/FormButton.vue'
import Alert from '@/components/Atoms/Alert.vue'
import FormInput from '@/components/Atoms/FormInput.vue'
import { useLegacyModalBridge } from '@/composables/useLegacyModalBridge'

const MODAL_ID = 'modalGetVmixToken'

const props = defineProps({
	vmixToken: {
		type: Object,
		default: () => ({}),
	},
	modalSize: {
		type: String,
		default: 'md',
		validator(v) {
			return ['xl', 'lg', 'md', 'sm'].some((size) => size === v)
		},
	},
})

const emit = defineEmits(['modal-cancel', 'modal-dismiss'])

const accessKey = computed(() => props.vmixToken.secret)

const { isVisible, hide } = useLegacyModalBridge(MODAL_ID)

const dismiss = () => {
	emit('modal-cancel')
	hide()
	emit('modal-dismiss')
}
</script>

<template>
	<ModalBox
		v-model="isVisible"
		:size="modalSize"
		hide-close
		header-class="!hidden"
		wrapper-classes="lg:h-auto lg:max-h-none"
		@close="dismiss"
	>
		<div class="px-6 pt-6">
			<h4 class="text-s-xl mb-4">"{{ vmixToken.name }}" access token</h4>
			<p class="text-s-s mb-2">Access Key</p>
			<div class="flex items-center gap-x-3 mb-3">
				<FormInput
					class="flex-1 !w-auto"
					:modelValue="accessKey"
					readonly
					customClasses="!bg-transparent !border-0"
				/>
				<ButtonCopyToClipboard :text="accessKey" />
			</div>
			<Alert
				type="normal"
				text="We do not store the access keys, so ensure you save them in a secure location."
				class="text-dark-7 text-s-s flex mt-3 p-2"
			/>
		</div>
		<template #footer>
			<div class="flex justify-end p-6 border-t border-surface-3">
				<FormButton type="surface-4" size="md" @click="dismiss">
					Close
				</FormButton>
			</div>
		</template>
	</ModalBox>
</template>
